import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'; // 1. Redux imports
import DB from '../../DAL/DB';
import { TYPES } from '../reducer'; // 2. Action Types
import { pushData } from '../utilities/pushData'; // 3. New simple Action Creator
import loadProjectSchedule from './loadProjectSchedule';

const projects = new DB.Projects();

export default function useLoadSchedule(id) {
  const dispatch = useDispatch();

  // 4. Selectors
  // We grab the project to watch for changes.
  const project = useSelector(state => state.project);
  const projectId = project?.id;

  // Effect 1: Load Project by ID (when accessing from URL/ProjectDetail)
  useEffect(function () {
    (async function () {
      if (!id) return;

      const {
        ok,
        data: [fetchedProject],
      } = await projects.get(id);

      if (ok) {
        const schedule = loadProjectSchedule(fetchedProject);
        
        // 1. Push schedule data
        dispatch(pushData(schedule));
        
        // 2. Update projects map
        dispatch({
          type: TYPES.PROJECTS, 
          payload: { [fetchedProject.id]: fetchedProject }
        });

        /*
        if (fetchedProject?.inspection?.date) {
          console.log('this should work');
          
          let obj = {
            time: fetchedProject.inspection.date,
          };
          
          if (fetchedProject.inspection.duration) {
            obj.duration = fetchedProject.inspection.duration;
          }

          // Keeping your timeout logic (race condition fix)
          setTimeout(() => { 
            dispatch(pushData(obj));
          }, 500);
        }
        */  
        if (fetchedProject?.inspection?.inspector) {
          dispatch(pushData({ inspector: fetchedProject.inspection.inspector }));
        }  
      }
    })();
  }, [id, dispatch]);

  // Effect 2: Update Schedule when Project State Changes
  useEffect(
    function () {
      if (!projectId) return;

      // Calculate schedule from the current Redux state project
      const schedule = loadProjectSchedule(project);

      // Clean empty keys
      for (let k in schedule) {
        if (!schedule[k]) delete schedule[k];
      }

      // REDUX IMPROVEMENT:
      // In your old code, you had to do: push({date: state.date, ...schedule})
      // to prevent overwriting date with null.
      // In Redux, our reducer is { ...state, ...payload }, so we only
      // need to dispatch the new schedule fields. Existing date/time remain untouched automatically.
      dispatch(pushData(schedule));
    },
    [projectId, dispatch] // We trigger this when the ID changes (or you can use [project] if deep updates matter)
  );
}